module.exports = "/assets/data/066c65a5b839db44a636391f6d236e63-M11.data.json";